export default __webpack_public_path__ + "static/media/DPE_E_WHITE.81809802.png";